import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { getCustomers } from 'services/salesperson-kpi/customerService';
import BaseDropdown from '../BaseDropdown';
import { OptionItem } from 'components/common/models/BaseClass';
const SpCustomerDropdown = ({
  keyId,
  handleChange,
  selectedIdStr = `${-1}_${false}`
}) => {
  const [source, setSource] = useState([]);
  useEffect(() => {
    getCustomers()
      .then(res => {
        if (res) {
          let source = [];
          source.push(new OptionItem(`${-1}_${false}`, '-- All --'));
          source = source.concat(
            res.data?.map(
              x => new OptionItem(`${x.id}_${x.isProspect}`, x.name, x)
            )
          );
          setSource(source);
        }
      })
      .catch(err => console.log(err));
  }, []);

  return (
    <>
      <BaseDropdown
        sources={source}
        // selectedOptions={`${formData?.customerId}_${formData?.isProspect}`}
        selectedOptions={selectedIdStr}
        // handleChange={opts => handleCustomerChange('customerId', opts)}
        handleChange={opts => handleChange(keyId, opts)}
        isMulti={false}
      />
    </>
  );
};

SpCustomerDropdown.propTypes = {
  collapseValues: PropTypes.bool,
  keyId: PropTypes.string,
  handleChange: PropTypes.func,
  selectedIdStr: PropTypes.string,
};

export default SpCustomerDropdown;
